import { useEffect } from "react";
import { notifyPageView } from "../../analytics/useAnalyticsEventTracker";
import { setMetaTags } from "../../helpers/pageMeta";
import { stateType } from "../../state";
import { useStyles } from "../DataIngestion/DataIngestion";
import { CorrelationBox } from "./CorrelationBox";
import { ChooseVarsBox, DropDown } from "./DualChartBox";

export function VariableCorrelations({ state }: stateType) {
	const classes = useStyles();
	useEffect(() => {
		setMetaTags();
		window.scrollTo(0, 0);
		notifyPageView("Variable Correlations Page", window.location.pathname);
	}, []);
	return (
		<div className={classes.root}>
			<div className={classes.grid}>
				<div className={classes.title}>Data Correlations</div>
			</div>

			<div className={classes.grid}>
				<div className={classes.subTitle}>
					Shows how pairs of columns are related (correlated) to each
					other.
				</div>
			</div>

			<div className={classes.grid}>
				<div
					style={{
						height: "40px",
						width: "100%",
						display: "flex",
						flexDirection: "row",
						marginBottom: "0px",
						marginTop: "0px",
						zIndex: 100,
						marginLeft: "-40px",
					}}
				>
					<DropDown state={state} i={0}></DropDown>
					<DropDown state={state} i={1}></DropDown>
				</div>
			</div>
			<div className={classes.grid}>
				<ChooseVarsBox state={state}></ChooseVarsBox>
				<div className={classes.divider}></div>
				<CorrelationBox state={state}></CorrelationBox>
			</div>
		</div>
	);
}
